module.exports = "https://p.cds.unp.clasificados.pe/aristotelica-extralight.bbba6de0399540584ddca2e80aecd7aa.woff2";